import VueCountdown from '@chenfengyuan/vue-countdown';

export function setupVueCountdown(app) {
    app.component(VueCountdown.name, VueCountdown);
}
